import { getAddressLine, getBrandDetailsFromBrandJson } from "../util/share";
import { formatPhone } from "./formatPhone";
import { FranchiseDetail } from "./models/FranchiseDetail";

export const getBubbleContent = async (franchiseDetail: FranchiseDetail): Promise<string> => {
    let addr1AndAddr2 = getAddressLine(franchiseDetail,true);
    const addrLine3 = `${(franchiseDetail.city && franchiseDetail.city.length > 0) ? franchiseDetail.city + ', ' : ''}
        ${(franchiseDetail.state && franchiseDetail.state.length > 0) ? franchiseDetail.state + ', ' : ''}
        ${(franchiseDetail.country && franchiseDetail.country.length > 0) ? franchiseDetail.country + ', ' : ''}
        ${(franchiseDetail.zipCode && franchiseDetail.zipCode.length > 0) ? franchiseDetail.zipCode : ''}
    `;
   
    const websiteTrackingNumber: any = franchiseDetail.websiteTrackingPhone[0] ? franchiseDetail.websiteTrackingPhone[0] : franchiseDetail.phoneNumber;
    let reqHref = `https://${window.location.hostname}/schedule-appointment`;
    const requestEstimateText = (document.getElementById('request-estimate-label') as HTMLInputElement)?.value;
    const showWebsiteText = (document.getElementById('view-website-label') as HTMLInputElement)?.value;

    const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
    const brandData = await getBrandDetailsFromBrandJson(conceptCode);
    const crownpeakURL = brandData.include_crownpeakURL;
    return `<div class="modal-body">
    <div class="modal-heading">${franchiseDetail.doingBusinessAs}</div>
    ${addr1AndAddr2}
    <p class="modal-text">
        ${addrLine3}
    </p>
    </div>
    <div class="modal-cta">
    <a href="tel:${websiteTrackingNumber}" class="modal-link">${websiteTrackingNumber.includes('(') ? websiteTrackingNumber : formatPhone(websiteTrackingNumber)}</a>
    <a href=${brandData?.request_button_link_type ? brandData?.request_button_link_type : reqHref} id="requestEstimatePopup" class="modal-link">${requestEstimateText}</a>
    ${crownpeakURL ? `<a href="${franchiseDetail.crownpeak_weblocation_url}" class="modal-link">View Website</a>` :
    `<a href="${franchiseDetail.websiteUrl}" class="modal-link">${showWebsiteText}</a>`}
    </div>
    <input type="hidden" class="franchise-details" data-json='${JSON.stringify(franchiseDetail)}'/>
    `;

}

